exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.ngTable table.table {\n  margin-bottom: 5px !important;\n}\ndiv.ngTable th.header {\n  background-color: #FFF !important;\n}\n.ngTableTitle {\n  font-weight: bold !important;\n  background-color: #E8E8E8 !important;\n  text-align: left !important;\n}\n.filter-select {\n  font-weight: normal;\n  font-size: 12px;\n  min-width: 90px;\n}\n", ""]);

// exports
